import React from 'react';
import Logo from '../../../img/teamzorgportaal.svg';

const LogoZorgVerkeerMain = () => {
	return (
		<aside className='zorgverkeer'>
			<img src={Logo} alt='Team Zorgportaal - Hart voor het sociaal domein' />
		</aside>
	);
};

export default LogoZorgVerkeerMain;
